import React from 'react';
import AppApi from "../../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../../api/gallery";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Actions from '../../../store/actions';
import { useDispatch } from 'react-redux';


let validationSchema = Yup.object({
   measurementId: Yup.string().required("Measurement ID is required."),
   status: Yup.boolean().oneOf([true, false], "Status must be a boolean value.").required("Status is required."),
});

function GoogleAnalytics({ setPluginModel, data }) {
   const dispatch = useDispatch();

   return (
      <>
         <Formik
            initialValues={{
               measurementId: data?.measurementId || "",
               status: data?.status !== undefined ? data.status : true,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = await AppApi.googleAnalytics(values);
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                     dispatch(Actions.updatePlugin({ googleAnalytics: res?.data?.data }));
                  }
                  resetForm();
                  setSubmitting(false);
                  setPluginModel(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className=" form mt-1">
                     <div className="form-group flex-grow-1">
                        <label>Measurement ID</label>
                        <Field
                           name="measurementId"
                           type="text"
                           className="form-control rounded"
                           placeholder="Measurement ID"
                        />
                        <ErrorMessage component="small" className='text-danger' name="measurementId" />
                     </div>
                  </div>
                  <div className="form-check mt-2">
                     <Field name="status" className="form-check-input" type="checkbox" id="status" />
                     <label className="form-check-label" htmlFor="status">
                        Status
                     </label>
                  </div>
                  <div className="p-0 mt-2 text-left col-sm-12">
                     <div className="mb-1 d-flex justify-content-end form-group">
                        <button type="submit" disabled={isSubmitting} className="btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : "Save"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
         <hr />
         <div className="documentation mt-4">
            <h5>How to Obtain Your Google Analytics Measurement ID</h5>
            <p>To successfully integrate Google Analytics with your application, you need to obtain the Measurement ID. Follow these steps:</p>
            <ol>
               <li>
                  <strong>Log in to Google Analytics:</strong> Visit the <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer" className='text-primary'>Google Analytics website</a> and log in with your credentials.
               </li>
               <li>
                  <strong>Access the Admin Panel:</strong> After logging in, navigate to the Admin panel by clicking on the gear icon at the bottom left corner of the page.
               </li>
               <li>
                  <strong>Select Your Property:</strong> In the Property column, select the property for which you want to find the Measurement ID.
               </li>
               <li>
                  <strong>Go to Data Streams:</strong> Under the Property column, click on "Data Streams" and select the web data stream you want to use.
               </li>
               <li>
                  <strong>Find Your Measurement ID:</strong> On the Data Stream details page, you will see your Measurement ID at the top right corner. It usually starts with 'G-' followed by a series of numbers and letters.
               </li>
            </ol>
            <p>Once you have your Measurement ID, enter it in the respective field above to complete the integration.</p>
         </div>
         <br />
         <br />
      </>
   )
}

export default GoogleAnalytics



